var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22,
    r: 21,
    fill: "#0C1525",
    stroke: "url(#paint0_linear_9501_68790)",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9501_68790)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.8208 18.1442C27.6734 18.0995 27.5393 18.0193 27.4301 17.9106C27.321 17.8019 27.2402 17.6681 27.195 17.5208C26.9398 16.6559 26.5118 15.8517 25.9368 15.1569C25.3618 14.4622 24.6519 13.8913 23.8499 13.4788C23.0479 13.0663 22.1706 12.8209 21.271 12.7573C20.3715 12.6937 19.4683 12.8132 18.6163 13.1087C17.7643 13.4042 16.9811 13.8695 16.314 14.4765C15.647 15.0834 15.1101 15.8194 14.7357 16.6398C14.3613 17.4602 14.1573 18.3481 14.136 19.2497C14.1147 20.1513 14.2765 21.0478 14.6116 21.885C14.6884 22.0615 14.7046 22.2583 14.6577 22.445C14.6108 22.6316 14.5035 22.7974 14.3525 22.9167C13.6889 23.4092 13.1709 24.0719 12.8531 24.8347C12.5354 25.5975 12.4298 26.4321 12.5475 27.25C12.7312 28.3557 13.3053 29.359 14.1655 30.0776C15.0257 30.7962 16.115 31.1826 17.2358 31.1667H24.1666V24.845L23.0891 25.9225C22.932 26.0743 22.7215 26.1583 22.503 26.1564C22.2845 26.1545 22.0755 26.0669 21.921 25.9124C21.7665 25.7579 21.6788 25.5488 21.6769 25.3303C21.675 25.1118 21.759 24.9013 21.9108 24.7442L23.2325 23.4225C23.7013 22.9538 24.3371 22.6905 25 22.6905C25.6629 22.6905 26.2987 22.9538 26.7675 23.4225L28.0891 24.7442C28.1687 24.8211 28.2322 24.913 28.2759 25.0147C28.3196 25.1163 28.3426 25.2257 28.3435 25.3363C28.3445 25.447 28.3234 25.5567 28.2815 25.6591C28.2396 25.7616 28.1777 25.8546 28.0995 25.9328C28.0212 26.0111 27.9282 26.073 27.8258 26.1149C27.7234 26.1568 27.6136 26.1778 27.503 26.1769C27.3923 26.1759 27.283 26.1529 27.1813 26.1093C27.0796 26.0656 26.9877 26.0021 26.9108 25.9225L25.8333 24.845V31.1558C27.492 31.1227 29.0817 30.4858 30.3045 29.3646C31.5273 28.2433 32.2993 26.7146 32.4758 25.065C32.6082 23.553 32.2184 22.0414 31.3714 20.782C30.5243 19.5226 29.2711 18.5916 27.8208 18.1442Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9501_68790",
    x1: 2.5,
    y1: 64.5926,
    x2: 50.4216,
    y2: 59.8518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.150307,
    stopColor: "#44A9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.336372,
    stopColor: "#0080FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.548934,
    stopColor: "#0098F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74141,
    stopColor: "#009BF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.928887,
    stopColor: "#009BF8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9501_68790"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(12.5 12)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.e2220a1a89f8e5cdb3238bef533dc426.svg";
export { ForwardRef as ReactComponent };